import React, { useState, useEffect, useRef } from "react"
import { navigate } from "gatsby"
import PropTypes from "prop-types"
import { sendGTMEvent } from "../../utils/googleAnalytics"

const NextResult = ({ className }) => {
    const [resultList, setResultList] = useState([])
    const [resultIndex, setResultIndex] = useState(0)
    const didMountRef = useRef(false)

    useEffect(() => {
        if (typeof window == "object") {
            setResultList(
                JSON.parse(window.localStorage.getItem("result_list"))
            )
            setResultIndex(window.localStorage.getItem("result_index"))
        }
    }, [])

    useEffect(() => {
        const navigateResult = () => {
            navigate(resultList[Number(resultIndex)].fields.result_slug)
        }

        if (didMountRef.current && resultList?.length) {
            navigateResult()
        } else {
            didMountRef.current = true
        }

        if (typeof window == "object") {
            window.localStorage.setItem("result_index", resultIndex)
        }
    }, [resultIndex])

    const handleClick = back => {
        setResultIndex(
            back !== "back" ? Number(resultIndex) + 1 : Number(resultIndex) - 1
        )
    }

    return (
        <>
            {Number(resultIndex) < 4 && (
                <button
                    onClick={() => {
                        sendGTMEvent("widget complete click", `get next show`)
                        handleClick("")
                    }}
                    className={`${className ? className : ""}`}
                >
                    Get Next Show
                </button>
            )}
            {resultIndex !== "0" && (
                <button
                    onClick={() => {
                        sendGTMEvent(
                            "widget complete click",
                            `get previous show`
                        )
                        handleClick("back")
                    }}
                    className={`${className ? className : ""}`}
                >
                    Get Previous Show
                </button>
            )}
        </>
    )
}

NextResult.defaultProps = {
    className: "",
    back: false,
}

NextResult.propTypes = {
    className: PropTypes.string,
    back: PropTypes.bool,
}

export default NextResult
